import { featureFlagClient } from '@trello/feature-flag-client';
import { OrganizationFeature } from '@trello/product-features';
import { dontUpsell } from '@trello/config';
import getExperiment from 'app/scripts/lib/experiments/simple-test.coffee';

interface Organization {
  isFeatureEnabled: (feature: string) => boolean;
}

interface Board {
  getOrganization: () => Organization | null;
}

export function hasAdvancedChecklists(board: Board) {
  return (
    featureFlagClient.get('remarkable.advanced-checklists', false) &&
    board
      .getOrganization()
      ?.isFeatureEnabled(OrganizationFeature.AdvancedChecklists)
  );
}

export function hasUpsell() {
  return (
    featureFlagClient.get('remarkable.advanced-checklist-upsell', false) &&
    !dontUpsell &&
    featureFlagClient.get('remarkable.advanced-checklists', false) &&
    getExperiment('advancedChecklistUpsell').get('variation') === 'enabled'
  );
}
